import React from 'react';

import Navbar from './components/Navbar';

import moment from 'moment';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { Segment, Grid, Button, Header, Container, Icon, Modal, Table } from 'semantic-ui-react';

import './App.css';

class App extends React.Component {

  constructor() {
    super();
    this.state = {
      fromDate: moment(),
      toDate: moment(),
      data: false,
      loading: false,
      modalMessage: false
    }

    this.handleFromDateChange = this.handleFromDateChange.bind(this);
    this.handleToDateChange = this.handleToDateChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  fetchData(fromDate = moment(), toDate = moment()) {

    const fromCancellation = "&from_CoworkerContract_CancellationDate=" + fromDate.format();
    const toCancellation = "&to_CoworkerContract_CancellationDate=" + toDate.format();
    const source = 'https://spaces.nexudus.com/api/billing/coworkercontracts?size=150&orderby=CancellationDate' + fromCancellation + toCancellation;

    return fetch(source, {
      headers: new Headers({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Basic ' + btoa(localStorage.getItem('token'))
      })
    })
    .then(response => {
      if (!response.ok) {
        return Promise.reject(response.statusText);
      }
      return response.json();
    })
    .catch(error => alert(error));
  }

  handleClick() {
    if (localStorage.getItem('token')) {
      this.setState({
        loading: true
      });
      this.fetchData(this.state.fromDate, this.state.toDate)
        .then(data => {
          this.setState({
            data: data,
            loading: false
          });
        });
    } else {
      this.toggleModal();
    }
  }

  // You must be logged in
  toggleModal() {
    this.setState({
      modalMessage: !this.state.modalMessage
    });
  }

  handleFromDateChange(date) {
    this.setState({
      fromDate: date
    });
  }

  handleToDateChange(date) {
    this.setState({
      toDate: date
    });
  }

  render() {

    const {data} = this.state;

    const tableRows = data ? data.Records.map(member => (
      <Table.Row>
        <Table.Cell>{member.CoworkerFullName}</Table.Cell>
        <Table.Cell>{moment(member.CancellationDate).format('M/D/Y')}</Table.Cell>
        <Table.Cell>{member.ToStringText}</Table.Cell>
      </Table.Row>
    )) : [];

    console.log(this.state);

    return (
      <div className="App" style={{position: "relative", minHeight: "100vh", paddingBottom: "100px"}}>
        <Navbar />
        <Segment vertical loading={this.state.loading}>
          <Container textAlign="center">
            <Header as="h1">Cancellations</Header>
            <span>From date:</span>
            <DatePicker selected={this.state.fromDate} onChange={this.handleFromDateChange} />
            <span>To date:</span>
            <DatePicker selected={this.state.toDate} onChange={this.handleToDateChange} />
            <Button onClick={this.handleClick} content='Go' />
            {tableRows[0] &&
              <Table celled color='violet'>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Name</Table.HeaderCell>
                    <Table.HeaderCell>Date of Cancellation</Table.HeaderCell>
                    <Table.HeaderCell>Contract Type</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {tableRows}
                </Table.Body>
              </Table>
            }
          </Container>
        </Segment>
        <Segment vertical inverted style={{position: "absolute", bottom: 0, width: "100%"}}>
          <Container>
            <Grid divided>
              <Grid.Row>
                <Grid.Column width={4}>
                  Cancellations
                </Grid.Column>
                <Grid.Column width={4}>

                </Grid.Column>
                <Grid.Column width={8}>
                  This beautiful app is brought to you by <a href="https://alexperez.ninja" target="_blank" rel="noopener noreferrer">Alex Perez</a>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Container>
        </Segment>
        <Modal open={this.state.modalMessage} onClose={this.toggleModal} basic size="small">
          <Header icon="ban" content="You Must Be Logged In" />
          <Modal.Content>
            <p>Srsly</p>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={this.toggleModal} color='green' inverted>
              <Icon name="checkmark" />
              Ok
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js